export default __webpack_public_path__ + "static/media/program_2.c29ee12f.jpg";